// extracted by mini-css-extract-plugin
export var container = "ViewMoreArticles-module--container--WZAkK";
export var cover = "ViewMoreArticles-module--cover--U37wy";
export var post = "ViewMoreArticles-module--post--PDLno";
export var sectionTitle = "ViewMoreArticles-module--sectionTitle--EmL1c";
export var title = "ViewMoreArticles-module--title--hfgKK";